module.exports = __webpack_public_path__ + "img/lang_w.419ea897.svg";